// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"S2-z","colorTextValue":"T2-z","swatches":"U2-z","collapseLink":"V2-z","isCollapsed":"W2-z","dropdown":"X2-z","disabled":"Y2-z"};